import { createSlice } from "@reduxjs/toolkit";
import { fetchProgramAssignmentSurvey } from "redux/actions/survey/surveyAction";
import { fetchSurveyModules } from "redux/actions/survey/surveyAction";

const initialState = {
  surveyModuleSelectedFilter: {
    status: "Active",
  },
  surveryModulesList: [],
  surveyModuleListTotalCount: 0,
  surveyModuleListLoading: false,
  surveyModuleListError: false,
  surveyModuleCreateStep: 1,
  surveyModuleType: "Survey",
  surveyModuleCreateName: "",
  surveyModuleCreateDescription: "",
  surveyModuleStep1ErrValidate: false,
  allSurveyModuleQuestions: [],
  selectedSurveyModuleQuestions: [],
  surveyModuleStep2ErrValidate: false,
  programAssignmentSurvey: {},
  programAssignmentLoading: false,
  programAssignmentDetail: {},
  programListPage: 1,
  // filter states
  programNameSearch: "",
  programFilters: [],
  orgFilters: [],
  clinicFilters: [],
  roleFilters: [],
  userTypeFilters: [],
  userGroupFilters: [],
  userFilters: [],
  programAssignmentStatus: "All",
  selectedSurveyModulePrograms: [],
  surveyModuleStep3ErrValidate: false,
  selectedProgramsName: [],
  selectedProgramsOrg: [],
  selectedProgramsClinic: [],
  selectedProgramsRole: [],
  selectedProgramsType: [],
  selectedProgramsGroup: [],
  selectedProgramsUser: [],
};

export const surveyModule = createSlice({
  name: "surveyModule",
  initialState,
  reducers: {
    resetState: () => initialState,
    setSelectedSurveyModuleSelectedFilter: (state, { payload }) => {
      state.surveyModuleSelectedFilter[payload.type] = payload.data;
    },
    setSelectedProgramsName: (state, { payload }) => {
      state.selectedProgramsName = payload;
    },
    setSelectedProgramsOrg: (state, { payload }) => {
      state.selectedProgramsOrg = payload;
    },
    setSelectedProgramsClinic: (state, { payload }) => {
      state.selectedProgramsClinic = payload;
    },
    setSelectedProgramsRole: (state, { payload }) => {
      state.selectedProgramsRole = payload;
    },
    setSelectedProgramsType: (state, { payload }) => {
      state.selectedProgramsType = payload;
    },
    setSelectedProgramsGroup: (state, { payload }) => {
      state.selectedProgramsGroup = payload;
    },
    setSelectedProgramsUser: (state, { payload }) => {
      state.selectedProgramsUser = payload;
    },
    setSurveyModuleCreateStep: (state, { payload }) => {
      state.surveyModuleCreateStep = payload;
    },
    setSurveyModuleCreateName: (state, { payload }) => {
      state.surveyModuleCreateName = payload;
    },
    setSurveyModuleType: (state, { payload }) => {
      state.surveyModuleType = payload;
    },
    setSurveyModuleCreateDescription: (state, { payload }) => {
      state.surveyModuleCreateDescription = payload;
    },
    setSurveyModuleStep1ErrValidate: (state, { payload }) => {
      state.surveyModuleStep1ErrValidate = payload;
    },
    setAllSurveyModuleQuestions: (state, { payload }) => {
      state.allSurveyModuleQuestions = payload;
    },
    setSelectedSurveyModuleQuestions: (state, { payload }) => {
      state.selectedSurveyModuleQuestions = payload;
    },
    setSurveyModuleStep2ErrValidate: (state, { payload }) => {
      state.surveyModuleStep2ErrValidate = payload;
    },
    setSelectedSurveyModulePrograms: (state, { payload }) => {
      state.selectedSurveyModulePrograms = payload;
    },
    setSurveyModuleStep3ErrValidate: (state, { payload }) => {
      state.surveyModuleStep3ErrValidate = payload;
    },
    setAssignmentState: (state, { payload }) => {
      // payload is an object where key is the state and data is the value
      // set value if state exists in initialState
      Object.keys(payload).forEach((key) => {
        if (key in initialState) {
          state[key] = payload[key];
        }
      });
    },
  },
  extraReducers: {
    [fetchSurveyModules.pending]: (state) => {
      state.surveyModuleListLoading = true;
    },
    [fetchSurveyModules.fulfilled]: (state, { payload }) => {
      state.surveryModulesList = payload?.results;
      state.surveyModuleListTotalCount = payload?.count;
      state.surveyModuleListLoading = false;
    },
    [fetchSurveyModules.rejected]: (state) => {
      state.surveyModuleListLoading = false;
      state.surveyModuleListError = true;
    },
    [fetchProgramAssignmentSurvey.pending]: (state) => {
      state.programAssignmentLoading = true;
    },
    [fetchProgramAssignmentSurvey.fulfilled]: (state, action) => {
      state.programAssignmentSurvey = {
        ...action.payload,
        results: action.payload.results || [],
      };
      state.programAssignmentLoading = false;
    },
    [fetchProgramAssignmentSurvey.rejected]: (state) => {
      state.programAssignmentLoading = false;
    },
  },
});

export const {
  resetState,
  setSurveyModuleCreateStep,
  setSurveyModuleCreateName,
  setSurveyModuleType,
  setSurveyModuleCreateDescription,
  setSurveyModuleStep1ErrValidate,
  setAllSurveyModuleQuestions,
  setSelectedSurveyModuleQuestions,
  setSurveyModuleStep2ErrValidate,
  setSelectedSurveyModulePrograms,
  setSurveyModuleStep3ErrValidate,
  setAssignmentState,
  setSelectedProgramsName,
  setSelectedProgramsOrg,
  setSelectedProgramsClinic,
  setSelectedProgramsRole,
  setSelectedProgramsType,
  setSelectedProgramsGroup,
  setSelectedProgramsUser,
  setSelectedSurveyModuleSelectedFilter,
} = surveyModule.actions;

export default surveyModule.reducer;
